import { usePage } from "@inertiajs/react"
import { useEffect } from "react"

import { registerPwaDeviceIfStandalone } from "@/lib/pwa-device"
import type { SharedData } from "@/types"

export function PwaDeviceRegistrar() {
  const { auth } = usePage<SharedData>().props
  const userId = auth?.user?.id

  useEffect(() => {
    if (!userId) return

    const register = () => {
      void registerPwaDeviceIfStandalone(userId)
    }

    register()

    if (typeof window === "undefined") return

    const standalone = window.matchMedia("(display-mode: standalone)")
    const overlay = window.matchMedia("(display-mode: window-controls-overlay)")
    standalone.addEventListener("change", register)
    overlay.addEventListener("change", register)

    return () => {
      standalone.removeEventListener("change", register)
      overlay.removeEventListener("change", register)
    }
  }, [userId])

  return null
}
